<template>
  <div>
    <NavBar></NavBar>
    <h1> PANTALLA DE SERVIDOR INSPECCION</h1>
  </div>
</template>

<script>
import NavBar from '../../../components/NavBar.vue'

export default {
  name: 'ServidorInspeccion',

  components: {
      'NavBar': NavBar
  }
}
</script>